import { all, fork } from 'redux-saga/effects';
import { enteredShowPageEffects } from '@integration-frontends/integration/core/application/select-attachment/state/effects/show-page/entered-show-page';
import { showPageSearchEffects } from '@integration-frontends/integration/core/application/select-attachment/state/effects/show-page/search';

export function* showPageEffects() {
  yield all([fork(enteredShowPageEffects), fork(showPageSearchEffects)]);
}
